"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var LinkInputBox = (function (_super) {
    __extends(LinkInputBox, _super);
    function LinkInputBox(props) {
        var _this = _super.call(this, props) || this;
        _this.previousLink = "";
        _this.onFocus = function (event) {
            _this.previousLink = _this.href;
            if (_this.props.onInputFocus) {
                _this.props.onInputFocus(event);
            }
        };
        _this.onBlur = function (event) {
            if (_this.props.onInputBlur) {
                _this.props.onInputBlur(event, _this.href);
            }
        };
        _this.onKeyPress = function (event) {
            switch (event.key) {
                case "Enter":
                    event.preventDefault();
                    _this.props.blurInput();
                    break;
                case "Escape":
                    event.preventDefault();
                    (0, mobx_1.runInAction)(function () {
                        _this.href = _this.previousLink;
                        _this.props.blurInput();
                    });
                    break;
                default:
                    break;
            }
        };
        _this.onLinkChange = function (event) {
            _this.href = event.target.value;
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
        };
        _this.href = _this.props.href || "";
        return _this;
    }
    LinkInputBox.prototype.render = function () {
        return (react_1.default.createElement("input", { className: "editor-toolbar__component link-input-box", type: "text", value: this.href, onChange: this.onLinkChange, onFocus: this.onFocus, onBlur: this.onBlur, onClick: this.props.onInputClick, onKeyUp: this.onKeyPress, ref: this.props.getTextInputElement, placeholder: this.props.placeholder }));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], LinkInputBox.prototype, "href", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], LinkInputBox.prototype, "onLinkChange", void 0);
    LinkInputBox = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], LinkInputBox);
    return LinkInputBox;
}(react_1.default.Component));
exports.default = LinkInputBox;
